module.exports = __webpack_public_path__ + "static/img/zjgn01.8249e23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doubleQianNiu/zjgn01.jpg
// module id = 1424
// module chunks = 0